// extracted by mini-css-extract-plugin
module.exports = {"select":"Form-module--select--2fUay"};